export type ProfileAgeDisplay = {
    age: number;
    formattedBirthdate: string;
};

export function getProfileAgeDisplay(
    birthdate: string | undefined,
    today: Date = new Date(),
): ProfileAgeDisplay | null {
    if (!birthdate) {
        return null;
    }

    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthdate);
    if (!match) {
        return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const validationDate = new Date(Date.UTC(year, month - 1, day));
    if (
        validationDate.getUTCFullYear() !== year ||
        validationDate.getUTCMonth() !== month - 1 ||
        validationDate.getUTCDate() !== day
    ) {
        return null;
    }

    let age = today.getFullYear() - year;
    const birthdayHasPassed =
        today.getMonth() + 1 > month || (today.getMonth() + 1 === month && today.getDate() >= day);
    if (!birthdayHasPassed) {
        age--;
    }
    if (age < 0) {
        return null;
    }

    return {
        age,
        formattedBirthdate: `${match[3]}-${match[2]}-${match[1]}`,
    };
}
